import cjson from 'compressed-json';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription, SubscriptionLike, Subject } from 'rxjs';

import { PersonSearchService } from 'src/app/_services/person-search.service';
import { environment } from "../../../environments/environment";
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { ReportOverLoaders } from './ReportOverviewLoaders';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { DataService } from 'src/app/data.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimilarCandidateFilterComponent } from 'src/app/similar-candidate-filter/similar-candidate-filter.component';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { JdDataService } from 'src/app/jd-data.service';
import { ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { Location } from '@angular/common';
import * as _ from 'underscore';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

declare var google;

const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009",
  "europe": "150"
}

@Component({
    selector: 'app-report-overview-tab',
    templateUrl: './report-overview-tab.component.html',
    styleUrls: ['./report-overview-tab.component.scss'],
    standalone: false
})
export class ReportOverviewTabComponent implements OnInit {
  companyDetails: any;
  topLocations: any[] = [];
  companiesGaining: any[] = [];
  companiesLosing: any[] = [];
  school: any[] = [];
  fieldOfStudy: any[] = [];
  skills: any[] = [];
  titles: any[] = [];
  currentCompanyName: any;
  dataSourceWorkCountry: any = [];
  gross_additions_by_month: number = 0;
  hireDepartureTalentMovement: any = {};
  showSchoolLoader: boolean = true;
  professionalsCount: any;
  medianTanuresCount: any;
  currentCompany: any[] = []
  currentIndustry: any[] = []
  changedJobCount: any;
  likeToMoveCount: any;
  genderDiversityMale: any;
  genderDiversityFemale: any;
  talentfilterdata: any = {};

  reportOverViewLoaders: ReportOverLoaders;

  subscriptions: Array<Subscription> = [];

  primaryCompanyInformation: any = {};

  /**query params of insights */
  queryParams = {}

  aggregateCount: number = 50;
  overviewDataForAISummary: {} = {};
  insightsExportSubscription: Subscription = null;

  subscriptionsLike: SubscriptionLike[] = [];

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')
    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  hasJobDemand: boolean = false;
  combinedAggregates: any = {};
  combinedLocation: any[] = [];
  combinedJobtitle: any[] = [];
  combinedSkills: any[] = [];
  combinedIndustry: any[] = [];
  jobDemandCount: string = '';
  medianSalary: string = '';
  currencyData: any[] = [];
  selectedCurrency: any = null;
  target_currency_rate: number = 1;
  target_fav_icon: string = 'fa-dollar-sign';
  currency: string = 'USD';
  currency_symbol: string = '$';
  aiSuggestions: any = {};
  filterData: any;
  overviewAggregates: any = {};
  filterType: string[] = [];
  isComingFromJD: boolean = false;
  isComingFromNLSearch: boolean = false;
  // @Output() openSlider:boolean=false
  @Output() openSlider = new EventEmitter<any>();
    isOpen = false;
    // openSlider:string=''
  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
  hasJobListingAccess:any;
  filters: any;

  constructor(
    private fusionChartService: FusionChartsService,
    private personSearchService: PersonSearchService,
    private localstorageservice: LocalStorageService,
    private aggService: AggregationService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private talentInsightsService: TalentInsightsService,
    private jdService: JdDataService,
    private location: Location,
    private jdDataService: JdDataService
  ) {
    this.startLoaders(); this.queryParams = this.route.snapshot.queryParams;
    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.setUpdatedData(null, true);
    });
    this.subscriptionsLike.push(statemanagementSub);
  }

  ngOnInit(): void {
    // TODO: I have to one by one sync the request of all aggregate calls and after I am done I can remove the subsc
    // this.setUpdatedData(null, true);
    // const overviewsub = this.personSearchService.gettalentinsights.subscribe(response => this.setUpdatedData(response, true));
    // this.subscriptions.push(overviewsub);
    if (this.jdDataService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdDataService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.getCurrencyData();
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails;
      this.filters = this.filterDataHandlerService.fetchFilterData;
      console.log('filterMethodEvent', this.filterData);
      this.getCurrencyData('filterChange');

    });
    this.subscriptions.push(filterMethodEvent);

    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.OVERVIEW) {
        this.filterType = res.filterType;
        this.getCurrencyData('jdUpdate');
      }
    });
    this.subscriptions.push(jdUpdateEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);

    const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if (!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(aiSuggestionSub);

    this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')

  }

  /** Extract query parama */
  getQueryParameter(key: string): string {
    const x = this.route.snapshot.queryParamMap.get('searchSource');
    return x;
  }

  fetchInsightsTabData() {
    // TODO: I have to one by one sync the request of all aggregate calls and after I am done I can remove the subsc
    // this.setUpdatedData(null, true);
    // const overviewsub = this.personSearchService.gettalentinsights.subscribe(response => this.setUpdatedData(response, true));
    // this.subscriptions.push(overviewsub);


  }

  /**
   * TODO : Ideally I should be able to remove the talentFilterData. Need to revisit this at the end.
   * @param talentFilterData
   */
  private setUpdatedData(talentFilterData?: any, callProffesionalCount = false) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.startLoaders();
    this.getChangeJobData();
    this.getGenderDiversity();
    // this.getLikelyToMove();
    callProffesionalCount && this.getProfessionalCount();
    this.getTopLocations();
    this.getSchool();
    this.getFieldOfStudy();
    this.getSkills();
    this.getTitles();
    this.getCompany();
    this.getIndustry();
    this.getMedianTanureCount();
    const aggReq = this.aggService.getRequestWithFilters();
    if ((!this.filterData && this.filterType?.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'functions' ||  this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle')
      || (this.filterType?.length > 0 && (this.filterType.includes('skill') || this.filterType.includes('jobTitle') || this.filterType.includes('companyIndustry') || this.filterType.includes('location')))) {

      this.getCurrency();
    } else if(this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch){
           this.hasJobDemand = false;
      this.jobDemandCount = '';
      this.medianSalary = '';
      this.localstorageservice.setItem('jobCurrency', 'USD');
          this.localstorageservice.setItem('currencyCountry', null);
    } else {
      this.setOverviewAggregates();
    }
  }

  getTopLocations() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.dataSourceWorkCountry = [];
    this.topLocations = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.topLocations = response?.data?.aggregations?.location ? response?.data?.aggregations?.location : [];
   this.markMap();
      this.reportOverViewLoaders.topLocationsFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        locations: this.topLocations
      }
    });
  }

  getSchool() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 50;
    aggReq.aggregatescount = this.aggregateCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);



    const filterData = this.filterDataHandlerService.fetchFilterData;
    this.school = [];
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      // const filterSchool = this.talentfilterdata && this.talentfilterdata.school && this.talentfilterdata.school.length ? this.talentfilterdata.school: [];
      const filterSchool = filterData?.schoolSelectedList?.length ? filterData.schoolSelectedList : [];
      const filterMap = new Map();
      filterSchool.map(item => {
        filterMap.set(item.key, true);
      })
      const schoolData = response?.data?.aggregations?.school?.slice(0, 5);
      this.school = filterSchool.length ? schoolData.filter(x => filterMap.get(x.key)) : schoolData;
      this.reportOverViewLoaders.schoolDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        schools: this.school
      }
    });

  }

  getFieldOfStudy() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.fieldOfStudy = [];
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.fieldOfStudy = response.data?.aggregations?.fieldofstudy.slice(0, 5);
      this.reportOverViewLoaders.fieldOfStudyDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        fieldofstudy: this.fieldOfStudy
      }
    });

  }

  getSkills() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.skills = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.skills = response.data?.aggregations?.skills.slice(0, 5);
      this.reportOverViewLoaders.skillsDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        skills: this.skills
      }
    });
  }

  getTitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.titles = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.titles = response.data?.aggregations?.[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.titlesDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        titles: this.titles
      }
    });
  }

  loadGoogleMap() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq = this.aggService.getRequestWithFilters();
    const continent = Array.isArray(aggReq.continentstobeincluded) ? aggReq.continentstobeincluded[0] : aggReq.continentstobeincluded;


    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: `world`,
        displayMode: 'markers',
        colorAxis: { colors: this.fusionChartService.LOCATION_COLOR_PALETTE }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }
    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  getCompany() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_company';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.currentCompany = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.currentCompany = response.data?.aggregations?.[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.companyDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        companies: this.currentCompany
      }
    });
  }

  getIndustry() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.currentIndustry = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.currentIndustry = response.data?.aggregations?.[aggReq.aggregatetype].slice(0, 5);
      this.reportOverViewLoaders.industryDataFetched = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        industries: this.currentIndustry
      }
    });
  }

  getProfessionalCount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = aggReq.preferredskills ? "skills" : 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.reportOverViewLoaders.isProfessionalCountCalled = false;
    this.personSearchService.getTotalAggs(aggReq, true).subscribe(res => {
      if (res && res.data) {
        this.professionalsCount = res.data.totalresultscount;
      }
      if(this.professionalsCount == 0) {
        this.jobDemandCount = '';
        this.medianSalary = '';
      }
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        totalresultcount: this.professionalsCount
      }
      this.reportOverViewLoaders.isProfessionalCountCalled = true;
    })
  }

  getMedianTanureCount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "total_tenure_median";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.reportOverViewLoaders.isMedianTanureCountCalled = false;
    this.personSearchService.getTotalAggs(aggReq, true).subscribe(res => {
      if (res.data && res.data.aggregations && res.data.aggregations.total_tenure_median) {
        this.medianTanuresCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
      }
      this.reportOverViewLoaders.isMedianTanureCountCalled = true;
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        medianTenure:  GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCount),
      }
    })
  }

  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

  getLikelyToMove() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "likelytomove";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((res: any) => {
      if (res && res.data && res.data.aggregations && res.data.aggregations.likelytomove) {
        if (res.data.aggregations.likelytomove.length != 0) { this.likeToMoveCount = res.data.aggregations.likelytomove.filter(x => x.key == 1)[0]?.doc_count }
        else { this.likeToMoveCount = 0; }
      }
      this.reportOverViewLoaders.isLikeToMoveCalled = true;
    })
  }


  getGenderDiversity() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response: any) => {
      if (response && response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender?.length > 0) {
        const male = response?.data?.aggregations?.gender.length > 0 && response?.data?.aggregations?.gender.filter(x => x.key == 'male') && response?.data?.aggregations?.gender.filter(x => x.key == 'male')[0]?.doc_count ? response?.data?.aggregations?.gender.filter(x => x.key == 'male')[0]?.doc_count : 0
        const female = response?.data?.aggregations?.gender.length > 0 && response?.data?.aggregations?.gender.filter(x => x.key == 'female') && response?.data?.aggregations?.gender.filter(x => x.key == 'female')[0]?.doc_count ? response?.data?.aggregations?.gender.filter(x => x.key == 'female')[0]?.doc_count : 0
        const totalCount = male + female;

        const malePercent = ((male * 100) / totalCount)
        const femalePercent = ((female * 100) / totalCount)

        this.genderDiversityMale = malePercent ? malePercent.toFixed(0) : 0
        this.genderDiversityFemale = femalePercent ? femalePercent.toFixed(0) : 0
      } else {
        this.genderDiversityFemale = 0;
        this.genderDiversityMale = 0;
      }
      this.overviewDataForAISummary = {
        ...this.overviewDataForAISummary,
        genderDiversity: {
          males: this.genderDiversityMale,
          females: this.genderDiversityFemale
        }
      }
      this.reportOverViewLoaders.isGenderDiversityCalled = true;
    })
  }

  getIndustryIcon(industryName) {
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `fa-solid fa-${iconName}`
  }

  getChangeJobData() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "changedjobs";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe(res => {
      if (res && res.data && res.data.aggregations && res.data.aggregations.changedjobs) {
        this.changedJobCount = res.data.aggregations.changedjobs.doc_count;
      }
      this.reportOverViewLoaders.isChangedJobCountCalled = true;
      this.overviewDataForAISummary = {
        ... this.overviewDataForAISummary,
        changedjobscount: this.changedJobCount
      }
    })

  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
handelRedirection(type: string, key: string) {
  if (this.isLocationEurope) return;
  this.filters = this.filterDataHandlerService.fetchFilterData;

  const redirectFilters: Partial<FilterParams> = {
    insightsFilterData: this.filters,
  };

  switch (type) {
    case 'location':      redirectFilters['mandatorylocations'] = [key]; break;
    case 'company':       redirectFilters['mandatorycompanies'] = [key]; break;
    case 'industry':      redirectFilters['mandatoryindustries'] = [key]; break;
    case 'school':        redirectFilters['mandatoryschools'] = [key]; break;
    case 'fieldofstudy':  redirectFilters['mandatoryeducationalmajors'] = [key]; break;
    case 'skills':        redirectFilters['mandatoryskills'] = [key]; break;
    case 'jobtitle':      redirectFilters['mandatoryjobtitles'] = [key]; break;
  }

 const aggReq = this.aggService.getRequestWithFilters();
  if (aggReq?.continentstobeincluded) {
    redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
  }
  if (aggReq?.nlsearchquery) {
    redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
  }

  const uniqueKey = this.hashService.generateUniqueHash();
  localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

  // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
  // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
  // that window.open() clones into the new tab.
  const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

  let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

  if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
    url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
  }

  window.open(url, '_blank');
}

  private startLoaders() {
    this.reportOverViewLoaders = {
      isProfessionalCountCalled: false,
      isMedianTanureCountCalled: false,
      isChangedJobCountCalled: false,
      isGenderDiversityCalled: false,
      isLikeToMoveCalled: false,
      topLocationsFetched: false,
      schoolDataFetched: false,
      fieldOfStudyDataFetched: false,
      skillsDataFetched: false,
      titlesDataFetched: false,
      industryDataFetched: false,
      companyDataFetched: false
    }
  }

  getCompanyInfo(companyname) {
    let companyData = [];
    if (companyname) {
      companyData = [{
        name: companyname
      }]
    } else return;

    companyData?.length &&
      this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
        if (res.status == 'success' && res.data) {
          let companyDetails = res.data[0]
          this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
          this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
          this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
          this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
          this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
          this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['id'] = companyDetails.id
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['key_id'] = companyDetails.id
          this.primaryCompanyInformation['twitter_url'] = companyDetails.twitter_url
          this.primaryCompanyInformation['github_url'] = companyDetails.github_url
          this.primaryCompanyInformation['facebook_url'] = companyDetails.facebook_url
        }
      });
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if (requestData?.data?.currentTab !== 'overview') return;

    const payloadForInsightsExport: ExportPayload = {
      tab: 'overview',
      totalresultcount: this.professionalsCount,
      changedjobscount: this.changedJobCount,
      genderDiversityMale: this.genderDiversityMale,
      genderDiversityFemale: this.genderDiversityFemale,
      medianTenure: GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCount),
      chartdetails: this.dataSourceWorkCountry?.length ? [{ type: 'google', data: this.dataSourceWorkCountry }] : [],
      toplocations: this.topLocations.slice(0, 5),
      topcompanies: this.currentCompany.slice(0, 5),
      topindustries: this.currentIndustry.map(industry => ({ ...industry, icon: this.getIndustryIcon(industry.key) })).slice(0, 5),
      school: this.school.slice(0, 5),
      fieldofstudy: this.fieldOfStudy.slice(0, 5),
      skills: this.skills.slice(0, 5),
      titles: this.titles.slice(0, 5),
      totaljobdemandcount: this.jobDemandCount ? this.jobDemandCount : '—',
      medianSalary: this.medianSalary ? this.medianSalary : '—',
      currencySymbol: this.currency_symbol,
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    const aggReq = this.aggService.getRequestWithFilters();
    aggReq.aggregatetype = "jobs_base_aggregates";
    aggReq.aggregatescount = 50;
    this.personSearchService.getTotalAggs(aggReq).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      if (response?.data?.totalresultscount == 0) {
        this.hasJobDemand = false;
        this.jobDemandCount = '0';
        this.medianSalary = '0';
      } else
        this.getCurrency();
    });
  }


  getJobsAggregates() {
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'median_salary',
      startindex: 0,
      resultsize: 10,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
   }
   if(this.isComingFromJD || this.isComingFromNLSearch){
        payload['jobDescriptionKeys'] = {
        jobtitles: jobtitles,
        mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
        skills: skills,
        mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
        locations: aggReq?.job_description_keys?.locations || [],
        mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
        mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
        companies: aggReq?.job_description_keys?.companies || [],
        mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
        industries: aggReq?.job_description_keys?.industries || [],
        mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
    }
    payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
    payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
   }
       this.sliderPayload = payload

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0)
      ))) {
        this.hasJobDemand = false;
        this.jobDemandCount = '';
        this.medianSalary = '';
      } else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
     this.hasJobDemand = false;
        this.jobDemandCount = '';
        this.medianSalary = '';
      } else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['median_salary'];
          this.hasJobDemand = false;
          this.overviewAggregates = tempData;
          this.setOverviewAggregates();


        })
      }



    } else {
      this.hasJobDemand = false;
      this.jobDemandCount = '';
      this.medianSalary = '';
    }
  }


formatNumber(value: number): string| number {
  if (value === null || value === undefined || isNaN(value)) return '0';

  const country = this.localstorageservice.getItem('currencyCountry');
  const absNum = Math.abs(value);

  // Optional: you can fetch dynamically if you store currency symbol
  const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';

  const format = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  };

  if (country?.toLowerCase() === 'india') {

    if (absNum >= 1e7) { // 1,00,00,000
      return format(value / 1e7) + 'Cr';
    }

    if (absNum >= 1e5) { // 1,00,000
      return format(value / 1e5) + 'L';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }

  else {

    if (absNum >= 1e9) {
      return format(value / 1e9) + 'B';
    }

    if (absNum >= 1e6) {
      return format(value / 1e6) + 'M';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }
}

  getCurrency() {
    this.hasJobDemand = true;
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      const currency = this.localstorageservice.getItem('jobCurrency');
      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
        }
      }
      this.getJobsAggregates();

    })
  }

  getCurrencyData(source?: string) {

    const filterData = this.filterDataHandlerService.fetchFilterData;
    const aggReq = this.aggService.getRequestWithFilters();
    if (filterData && filterData.locationSelectedList.length > 0) {
      if (source === 'filterChange') {
        const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);
            this.setUpdatedData(null, true);
          }
        })
      } else {
        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData(null, true);

      }
    } else if (this.jdDataService.isComingFromJobDescription) {
      if (source === 'jdUpdate') {
        if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
              this.localstorageservice.setItem('currencyCountry', res.data.country_name);
              this.setUpdatedData(null, true);
            }
          })
        } else{
           this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
          this.setUpdatedData(null, true);
        }
      } else {

        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData(null, true);
      }
    } else {
      this.currency = this.localstorageservice.getItem('jobCurrency');
      this.setUpdatedData(null, true);
    }
  }

  setOverviewAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.jobDemandCount = '';
        this.medianSalary = '';
      } else {
        this.jobDemandCount = this.formatNumberToIndianFormat(this.overviewAggregates?.job_demand?.doc_count) || '';
        if (this.target_fav_icon == 'fa-money-bill') {
          this.medianSalary = this.overviewAggregates?.median_salary_max ? `${this.currency} ${this.formatNumber((this.overviewAggregates?.median_salary_min?.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber((this.overviewAggregates?.median_salary_max.value) * this.target_currency_rate)}` : '0';
        } else this.medianSalary = this.overviewAggregates?.median_salary_max ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((this.overviewAggregates?.median_salary_min?.value * this.target_currency_rate))} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(this.overviewAggregates?.median_salary_max.value * this.target_currency_rate)}` : '0';
        if (this.overviewAggregates?.median_salary_min?.value == null || this.overviewAggregates?.median_salary_max?.value == null) {
          this.medianSalary = '';
        }
      }

    } else {
      this.hasJobDemand = false;
      this.jobDemandCount = '';
      this.medianSalary = '';
    }

    this.overviewDataForAISummary = {
      ...this.overviewDataForAISummary,
      totaljobdemandcount: this.overviewAggregates?.job_demand?.doc_count,
      medianSalary: this.medianSalary
    }
  }

    markMap() {
    const CharForworkCountry = [];
    CharForworkCountry.push(['Location', 'Professional count'])
    this.topLocations.forEach(x => {
      const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
      CharForworkCountry.push(dataObj);
    });
    this.dataSourceWorkCountry = CharForworkCountry;
    setTimeout(() => {
      this.loadGoogleMap();
    });
  }


  openJoblistSlider() {
    this.sendDataToSliderSubject.next(this.sliderPayload);
      this.toOpenSliderFromTabSubject.next({isOpen:true})
  }

}
